// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__("./node_modules/@xingternal/hops-webpack/lib/shims/build.js");
